import { render, staticRenderFns } from "./SeckillBox.vue?vue&type=template&id=114aefcf&scoped=true&"
import script from "./SeckillBox.vue?vue&type=script&lang=js&"
export * from "./SeckillBox.vue?vue&type=script&lang=js&"
import style0 from "./SeckillBox.vue?vue&type=style&index=0&id=114aefcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114aefcf",
  null
  
)

export default component.exports